<template>
    <div v-if="needEmailVerify">
        <template v-if="!inPopupBase">
            <button
                v-if="validState===''||!isPassCheck"
                class="btn w-[7.5rem] rounded-md normal-case my-1 sm:my-0"
                :class="[email===''||!isPassCheck?'btn-accent bg-gray-75':'gradient-primary']"
                :disabled="email===''||!isPassCheck"
                @click="validEmail"
            >
                驗證Email
            </button>

            <div
                v-else-if="validState==='00'"
                class="flex my-1"
            >
                <div class="flex items-center">
                    <SvgIcon
                        icon-name="valid-email-valid"
                        class="h-5 w-5 mr-1"
                    />
                </div>
                <p class="text-green-900 text-sm md:text-base">
                    驗證成功
                </p>
            </div>

            <div
                v-else-if="validState==='01'"
                class="flex my-1"
            >
                <div class="flex items-center">
                    <SvgIcon
                        icon-name="valid-email-error"
                        class="h-5 w-5 mr-1"
                    />
                </div>
                <p class="error-msg text-sm md:text-base">
                    驗證失敗，請重新輸入。
                </p>
            </div>
        </template>

        <PopupBase
            v-model:visiblePopup="visiblePopup"
            :closeicon="!visibleMessage"
            :modalWidth="'max-w-[95%] sm:max-w-[85%] md:max-w-[32rem]'"
            :params="{
                title: popupTitle,
            }"
            @handleClose="close"
        >
            <template
                v-if="!visibleMessage"
                #content
            >
                <div
                    v-if="isLoading"
                    class="flex-1 flex items-center justify-center flex-col bg-white bg-opacity-50 active:outline-none z-50 fixed inset-0"
                >
                    <div class="loading-animation">
                        <div />
                        <div />
                        <div />
                    </div>
                    <p class="text-base font-bold text-gray-700 tracking-wide">
                        {{ loadingText }}
                    </p>
                </div>

                <ol class="list-decimal text-base text-gray-700 ml-6 space-y-2">
                    <li>系統將於1~2分鐘內發送驗證碼到您此次變更之Email郵箱。</li>
                    <li>為確保個人資料安全性，此驗證碼自發送後起5分鐘內有效。</li>
                </ol>

                <div class="flex justify-between items-center space-y-2 mt-3">
                    <p class="text-base sm:text-lg break-all mx-2">
                        {{ email }}
                    </p>
                    <button
                        class="btn rounded-md"
                        :class="[isSendUpperLimit || counting?'btn-accent':'gradient-primary']"
                        :disabled="isSendUpperLimit || counting"
                        @click="sendOtp"
                    >
                        <vue-countdown
                            v-if="counting"
                            v-slot="{ totalSeconds }"
                            :time="60000"
                            @end="onCountdownEnd"
                        >
                            {{ totalSeconds }}秒後重新發送
                        </vue-countdown>
                        <p v-else-if="sendCount>0">
                            補發驗證碼
                        </p>
                        <p v-else>
                            發送驗證碼
                        </p>
                    </button>
                </div>
                <div
                    v-if="isSendUpperLimit"
                    class="flex"
                >
                    <div class="flex">
                        <SvgIcon
                            icon-name="valid-email-warning"
                            class="h-5 w-5 mr-1"
                        />
                    </div>
                    <p class="text-warning text-sm">
                        驗證碼已補發三次，請確認！
                    </p>
                </div>
                <!-- v-if="sendCount>0" -->
                <div
                    v-if="isShowInput"
                    class="space-y-2 mt-4"
                >
                    <div class="flex">
                        <p class="text-lg font-bold text-green-600">
                            請輸入6碼驗證碼
                        </p>
                    </div>
                    <div class="flex items-baseline">
                        <div class="flex pr-1 flex-shrink-0">
                            <p
                                v-if="identifier"
                                class="text-lg"
                            >
                                {{ `${identifier} -` }}
                            </p>
                        </div>
                        <div class="flex-grow sm:flex-grow-0">
                            <input
                                v-model.trim="otpCode"
                                class="input-base"
                                :class="[errorCount>0&&!isDisable || errorMessage === '驗證碼輸入錯誤，請重新輸入！'?'border-error':'']"
                                type="text"
                                autocomplete="off"
                                maxlength="6"
                                inputmode="numeric"
                                placeholder=""
                                :disabled="isErrorUpperLimit"
                                @input="validInput"
                            >
                            <p class="error-msg">
                                {{ errorMessage }}
                            </p>
                        </div>
                    </div>
                </div>
            </template>
            <template
                v-else
                #content
            >
                <div v-html="errorMessage" />
            </template>

            <template
                v-if="!visibleMessage"
                #action
            >
                <button
                    class="btn btn-accent rounded-full"
                    @click="close"
                >
                    取消
                </button>
                <button
                    class="btn rounded-full"
                    :class="[isDisable || !isShowInput?'btn-accent':'gradient-primary']"
                    :disabled="isDisable || !isShowInput"
                    @click="checkOtp"
                >
                    確定
                </button>
            </template>
            <template
                v-else
                #action
            >
                <button
                    class="btn gradient-primary rounded-full"
                    @click="goHome"
                >
                    確定
                </button>
            </template>
        </PopupBase>
    </div>
</template>

<script>
import { computed, ref, reactive, toRefs, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { getNeedEmailVerify, postCheck, postSentOTP, postReSentOTP, postVerifyOTP } from '@/apis/ValidEmail';
import PopupBase from '@/components/dialogs/Popup.vue';
import routeName from '@/router/constant.js';
import { integer } from '@/utils/rules/customRules.js';

export default {
    components: {
        PopupBase,
    },
    props: {
        /** 發送次數上限 */
        sendCountLimit: {
            type: Number,
            default: 4,
        },
        /** 錯誤次數上限 */
        errorCountLimit: {
            type: Number,
            default: 3,
        },
        /** 重新發送驗證碼時間 */
        reSendLimit: {
            type: Number,
            default: 1 * 60 * 1000,
        },
        /** 驗證的電子信箱 */
        email: {
            type: String,
            default: '',
        },
        /** 是否驗證通過 */
        isValid: {
            type: Boolean,
            default: false,
        },
        /** 儲存Email有效性驗證紀錄 */
        saveValidRecord: {
            type: Boolean,
            default: true,
        },
        /** 是否通過email相關檢核，false會Disable components */
        isPassCheck: {
            type: Boolean,
            default: true,
        },
        loadingText: {
            type: String,
            default: 'LOADING...',
        },
        needEmailVerify: {
            type: Boolean,
            default: true,
        },
        propsValidEmail: {
            type: Boolean,
            default: false,
        },
        inPopupBase: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:isValid', 'update:needEmailVerify', 'update:propsValidEmail', 'close'],
    setup(props, { emit }) {
        const router = useRouter();
        const store = useStore();
        const data = reactive({
            email: props.email,
            /** 驗證狀態 */
            validState: '',
            /** 已發送次數 */
            sendCount: 0,
            /** 已錯誤次數 */
            errorCount: 0,
            /** 重新發送倒數 */
            counting: false,
            /** 驗證碼是否逾期 */
            isOtpOverdue: false,
            /** 錯誤訊息 */
            errorMessage: '',
            visibleMessage: false,
            popupTitle: '',
            /** 識別碼 */
            identifier: '',
            // 輸入框
            isShowInput: false
        });
        /** 顯示彈窗 */
        const visiblePopup = ref(false);
        /** 輸入驗證碼 */
        const otpCode = ref('');
        const isLoading = ref(false);

        // const result = computed(() => store.state.services.validEmailArray);
        const applId = computed(() => store.state.permissions.userInfo.id);
        /** 初始化Data相關參數 */
        const initData = () => {
            data.email = props.email;
            data.validState = '';
            data.sendCount = 0;
            data.errorCount = 0;
            data.counting = false;
            data.isOtpOverdue = false;
            data.errorMessage = '';
            data.visibleMessage = false;
            data.popupTitle = '驗證Email';
            data.isShowInput = false;
        };

        initData();

        const checkNeedEmailVerify = () => {
            getNeedEmailVerify().then(res => {
                emit('update:needEmailVerify', res.data.flag);
            });
        };

        checkNeedEmailVerify();

        watch(() => props.propsValidEmail, (newV) => {
            if (newV) {
                validEmail();
            }
        }, { immediate: false, deep: true });

        watch(() => visiblePopup.value, (newV) => {
            if (!newV) {
                emit('update:propsValidEmail', false);
            }
        }, { immediate: false, deep: true });

        watch(() => data.validState, (newV) => {
            emit('update:isValid', newV === '00');
        }, { immediate: false, deep: true });

        /**
         * 監聽驗證email
         * 有驗證紀錄:取出資料
         * 無:初始化資料
         */
        watch(() => [props.email, props.isPassCheck], (newA, newB) => {
            // if (props.saveValidRecord && props.email !== '' && props.isPassCheck) {
            initData();
            // }
        }, { immediate: true, deep: true });

        /**
         * 未發送、錯誤達上限、驗證碼逾期
         */
        const isDisable = computed(() => {
            return data.sendCount > props.sendCountLimit || isErrorUpperLimit.value || data.isOtpOverdue || !validInput();
        });
        const isSendUpperLimit = computed(() => {
            return data.sendCount >= props.sendCountLimit;
        });
        const isErrorUpperLimit = computed(() => {
            return data.errorCount >= props.errorCountLimit;
        });
        const close = () => {
            // 發送上限、 驗證碼逾期 or 錯誤次數達上限 返回首頁
            if (isSendUpperLimit.value && (data.isOtpOverdue || isErrorUpperLimit.value)) {
                goHome();
            } else {
                visiblePopup.value = false;
                data.errorMessage = '';
                data.isShowInput = false;
            }
        };
        const onCountdownEnd = () => {
            data.counting = false;
        };
        /**
         * 檢查是否已驗證過電子信箱
         * 1.call 檢查是否已驗證過Api
         * 1-1:已驗證過 validState:00
         * 1-2:未驗證過打開彈窗 visiblePopup:true
         */
        const validEmail = () => {
            isLoading.value = true;
            data.counting = false;
            postCheck(applId.value, data.email).then(res => {
                if (res.data.exist) {
                    data.validState = '00';
                } else {
                    data.sendCount = res.data.sendTimes;
                    visiblePopup.value = true;
                    if (isSendUpperLimit.value) {
                        setSendOverMessege();
                    }
                }
            }).finally(() => {
                isLoading.value = false;
            });
        };
        const setSendOverMessege = () => {
            data.errorMessage = 'Email驗證因發送已達上限，請您重新申請，謝謝。';
            data.visibleMessage = true;
            data.popupTitle = '提醒您';
        };
        /**
         * 發送Otp
         */
        const sendOtp = () => {
            if (isSendUpperLimit.value || data.counting) {
                return;
            }
            isLoading.value = true;
            data.isShowInput = false;
            if (data.sendCount === 0) {
                postSentOTP(data.email).then(res => {
                    if (res.data.errorStatus === '') {
                        setSendData(res.data.otpCodePre, 1);
                    }
                    setTimeout(() => {
                        isLoading.value = false;
                        data.isShowInput = true;
                    }, 2000);
                }).catch(() => {
                    isLoading.value = false;
                });
            } else {
                postReSentOTP(data.email).then(res => {
                    setSendData(res.data.otpCodePre, res.data.sendTimes);
                    setTimeout(() => {
                        isLoading.value = false;
                        data.isShowInput = true;
                        if (data.sendCount > props.sendCountLimit) {
                            setSendOverMessege();
                        }
                    }, 2000);
                }).catch(() => {
                    isLoading.value = false;
                });
            }
        };

        const setSendData = (identifier, resendTimes) => {
            data.sendCount = resendTimes;
            data.isOtpOverdue = false;
            data.errorCount = 0;
            data.errorMessage = '';
            data.counting = data.sendCount < props.sendCountLimit;
            data.identifier = identifier;
            otpCode.value = '';
        };
        const goHome = () => {
            router.push({ name: routeName.HOME });
        };
        const checkOtp = () => {
            if (isDisable.value) {
                return;
            } else if (otpCode.value === '') {
                data.errorMessage = '請輸入驗證碼。';
                return;
            }

            const errorMessage = integer(otpCode.value, '請輸入數字!');
            if (errorMessage) {
                data.errorMessage = errorMessage;
                return;
            }

            data.errorMessage = '';
            isLoading.value = true;

            postVerifyOTP(otpCode.value, data.email).then(res => {
                data.errorCount = res.data.errorTimes;
                if (res.data.verify) {
                    data.validState = '00';
                    close();
                } else if (res.data.errorStatus === '1') {
                    data.errorMessage = '驗證碼輸入錯誤，請重新輸入！';
                } else if (res.data.errorStatus === '2') {
                    data.errorCount = props.errorCountLimit;
                } else if (res.data.errorStatus === '3') {
                    data.isOtpOverdue = true;
                }
                // res.data.cancelTransaction
                if (isSendUpperLimit.value && isErrorUpperLimit.value) {
                    data.errorMessage = `您所填寫的Email<br>${props.email}<br>驗證失敗，請重新申請，謝謝！`;
                    data.validState = '01';
                    data.visibleMessage = true;
                    data.popupTitle = '提醒您';
                } else if (isSendUpperLimit.value && data.isOtpOverdue) {
                    data.errorMessage = '輸入之驗證碼已無效，請重新申請，謝謝！';
                    data.visibleMessage = true;
                    data.popupTitle = '提醒您';
                } else if (isErrorUpperLimit.value) {
                    data.errorMessage = '驗證碼輸入錯誤，請點選補發驗證碼！';
                } else if (data.isOtpOverdue) {
                    data.errorMessage = '輸入之驗證碼已逾時，請點選補發驗證碼！';
                }
            }).finally(() => {
                isLoading.value = false;
            });

            otpCode.value = '';
        };

        const validInput = () => {
            if (otpCode.value) {
                data.errorMessage = integer(otpCode.value, '請輸入數字!') || '';
                if (data.errorMessage === '') {
                    data.errorMessage = otpCode.value.length !== 6 ? '請輸入6碼驗證碼' : '';
                }
            }
            return data.errorMessage === '';
        };

        return {
            ...toRefs(data),
            goHome,
            otpCode,
            visiblePopup,
            isLoading,
            isDisable,
            isSendUpperLimit,
            isErrorUpperLimit,
            validEmail,
            sendOtp,
            checkOtp,
            close,
            onCountdownEnd,
            validInput,
        };
    },
};
</script>
